import { FirestoreDataConverter } from "firebase/firestore";
import { omit } from "lodash";
import moment from "moment";
import Usuario from "../models/usuario";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class UsuarioDb extends BaseDb<Usuario, { usuarioId: string }> {
  _path: string = "usuarios/usuarioId";
  getConverter(): FirestoreDataConverter<Usuario> {
    return {
      fromFirestore: (snapshot) =>
        ({
          id: snapshot.id,
          email: snapshot.get("email"),
          nome: snapshot.get("nome"),
          cpf: snapshot.get("cpf"),
          origem: snapshot.get("origem"),
          preferencias: {
            lembreteCalculo: snapshot.get("preferencias.lembreteCalculo"),
            spam: snapshot.get("preferencias.spam"),
            vendaDescoberta: snapshot.get("preferencias.vendaDescoberta"),
            incompatibilidades: snapshot.get("preferencias.incompatibilidades"),
            mercadoInternacional: snapshot.get("preferencias.mercadoInternacional")
          },
          atualizadoAte: snapshot.get("atualizadoAte")
            ? moment(snapshot.get("atualizadoAte").toDate())
            : moment(),
          atualizadoEm: snapshot.get("atualizadoEm")
            ? moment(snapshot.get("atualizadoEm").toDate())
            : undefined,
          ultimaNota: snapshot.get("ultimaNota")
            ? moment(snapshot.get("ultimaNota").toDate())
            : undefined,
          dataInicio: snapshot.get("dataInicio")
            ? moment(snapshot.get("dataInicio").toDate())
            : undefined,
          dataInicioInternacional: snapshot.get("dataInicioInternacional")
            ? moment(snapshot.get("dataInicioInternacional").toDate())
            : undefined,
          pontoDePartidaInternacional: snapshot.get("pontoDePartidaInternacional")
            ? moment(snapshot.get("pontoDePartidaInternacional").toDate())
            : undefined,
          atualizarPorque: snapshot.get("atualizarPorque"),
          contaPai: snapshot.get("contaPai"),
          asUser: snapshot.get("asUser"),
          nomeAfiliado: snapshot.get("nomeAfiliado"),
          business: snapshot.get("business"),
          estatisticas: snapshot.get("estatisticas")
            ? {
                notas: snapshot.get("estatisticas.notas"),
                impostos: snapshot.get("estatisticas.impostos"),
              }
            : undefined,
          arquivado: snapshot.get("arquivado"),
          layoutPainel: snapshot.get("layoutPainel"),
          flag: snapshot.get("flag"),
          contato: snapshot.get("contato"),
          tour: snapshot.get("tour"),
          fotoDePerfil: snapshot.get("fotoDePerfil"),
          perfil: snapshot.get("perfil"),
          documento: snapshot.get("documento"),
          tipoDocumento: snapshot.get("tipoDocumento"),
          senhasPdf: snapshot.get("senhasPdf"),
          dadosEscritorio: snapshot.get("dadosEscritorio"),
        } as Usuario),
      toFirestore: (usuario: Usuario) => {
        return toFirestore({
          ...omit(usuario, ["id"]),
        });
      },
    };
  }
}
